import { MdLogout } from 'react-icons/md';
import styled from 'styled-components';

export const LogoutIcon = styled(MdLogout)`
  height: 1.5rem;
  width: 1.5rem;
`;
